export default [
  {name: '상품번호', value: 'PRODUCT_NO'},
  {name: '상품관리코드', value: 'PRODUCT_MANAGEMENT_CODE'},
  {name: '상품명', value: 'PRODUCT_NAME'}
];
